/** Bootstrap `sm` (576px). Viewports below this are `xs` (e.g. 320px phones). */
export const SM_BREAKPOINT = 576

/** Bootstrap `lg` (992px). V2 mobile layouts use `max-width: 991.98px` / `d-lg-none`. */
export const LG_BREAKPOINT = 992

